module.exports = __webpack_public_path__ + "static/media/bootcamps-logo.c7a76bb9.jpg";